import { useEffect } from 'react';

/* ★ THE ONE unsaved-changes browser guard (Principle 0).
 *
 * This effect existed as THREE byte-identical hand-rolled copies — VendorModal
 * (VendorDashboard), PrepaidModal (VendorDashboard) and ForecastWizard — each
 * written during 5b-safety for the same reason: a 6-10h data-entry session
 * (229 AE Model vendors) where an accidental tab close loses everything unsaved.
 * A fourth consumer (onboarding Step-6 6d) made the duplication worth closing, so
 * the effect moved here and all three callers were repointed in the SAME change —
 * the count went 3 → 1, never 4.
 *
 * ★ WHAT IS DELIBERATELY *NOT* SHARED: how each surface decides it is dirty.
 * VendorModal compares a useRef-frozen JSON snapshot of {f, renewals,
 * oneOffEntries}; PrepaidModal compares a snapshot of `f`; ForecastWizard tracks a
 * `dirtyIds` Set; Step-6 6d compares a projection of the editable vendor fields.
 * Those are genuinely different questions and unifying them would be a worse fork
 * than the one this file closes. The caller owns `isDirty`; this owns the browser.
 *
 * ★ KNOWN AND ACCEPTED (CLAUDE.md §12): Chromium suppresses beforeunload on a
 * tab-X close without prior user-activation. Refresh and in-page navigation fire
 * reliably. This is defence-in-depth, not a guarantee — surfaces should ALSO show
 * a visible dirty indicator, which each of them does.
 *
 * Modern browsers ignore any custom message and show their own dialog, so there is
 * nothing to parameterise: preventDefault + returnValue='' is the whole contract.
 */
export function useUnsavedChangesWarning(isDirty) {
  useEffect(() => {
    if (!isDirty) return;
    const handler = (e) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [isDirty]);
}

export default useUnsavedChangesWarning;
